// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"488":"web-spotlight","653":"survey"}[chunkId] || chunkId) + "." + {"244":"683a5842","488":"5acd54bb","653":"d975aba2"}[chunkId] + ".js";
};